// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lXmy","content":"styles_content__1XRME","row":"styles_row__dgd4j","footer":"styles_footer__ka33n","phraseLength":"styles_phraseLength__1W-CL"};